import { __assign, __extends } from "tslib";
import React, { Component } from 'react';
import { GALLERY_v4_CONSTS, experimentsWrapper } from '@wix/photography-client-lib'; // use blueprints
import SliderLeftArrow from './sliderLeftArrow';
import SliderRightArrow from './sliderRightArrow';
import { utils } from '../utils';
import { ProGalleryWrapper } from './proGalleryWrapper';
var ProGallerySlider = /** @class */ (function (_super) {
    __extends(ProGallerySlider, _super);
    function ProGallerySlider(props) {
        var _this = _super.call(this, props) || this;
        _this.galleryEventsHandler = _this.galleryEventsHandler.bind(_this);
        _this.customArrowsRenderer = _this.customArrowsRenderer.bind(_this);
        _this.initialArrowsFocus = _this.initialArrowsFocus.bind(_this);
        _this.tabFlowArrowsFocus = _this.tabFlowArrowsFocus.bind(_this);
        _this.state = {
            activeIndex: _this.props.activeIndex || 0,
        };
        return _this;
    }
    ProGallerySlider.prototype.galleryEventsHandler = function (eventName, eventData) {
        var actions = this.props.actions;
        switch (eventName) {
            case GALLERY_v4_CONSTS.events.CURRENT_ITEM_CHANGED:
                actions.setCurrentItem(eventData);
                break;
            case GALLERY_v4_CONSTS.events.ITEM_CLICKED:
                break;
            default:
                break;
        }
    };
    ProGallerySlider.prototype.customArrowsRenderer = function (direction) {
        var _this = this;
        if (direction === 'left') {
            return (React.createElement("button", { tabIndex: "-1", ref: function (ref) { return (_this.leftArrowElement = ref); }, className: "pro-gallery-slider-arrow" },
                React.createElement(SliderLeftArrow, null)));
        }
        else if (direction === 'right') {
            return (React.createElement("button", { tabIndex: "-1", ref: function (ref) { return (_this.rightArrowElement = ref); }, className: "pro-gallery-slider-arrow" },
                React.createElement(SliderRightArrow, null)));
        }
    };
    ProGallerySlider.prototype.componentDidUpdate = function (prevProps) {
        if (!utils.isSmallScreen()) {
            if (prevProps.activeIndex !== this.props.activeIndex) {
                if (this.props.activeIndex <= 0) {
                    this.rightArrowElement && this.rightArrowElement.focus();
                }
                else if (this.props.activeIndex >= this.props.totalItemsCount - 1) {
                    this.leftArrowElement && this.leftArrowElement.focus();
                }
            }
            if (this.props.refocusArrows && !prevProps.refocusArrows) {
                this.tabFlowArrowsFocus();
            }
        }
    };
    ProGallerySlider.prototype.tabFlowArrowsFocus = function () {
        // in the tab flow, if left arrow exists, is should be focus after 'X' button (the last one in the flow).
        if (this.props.activeIndex > 0) {
            this.leftArrowElement && this.leftArrowElement.focus();
        }
        else {
            this.rightArrowElement && this.rightArrowElement.focus();
        }
    };
    ProGallerySlider.prototype.initialArrowsFocus = function () {
        if (this.props.activeIndex >= this.props.totalItems - 1) {
            this.leftArrowElement && this.leftArrowElement.focus();
        }
        else {
            this.rightArrowElement && this.rightArrowElement.focus();
        }
    };
    ProGallerySlider.prototype.getGallerySlider = function () {
        var _a = this.props, isPreview = _a.isPreview, styles = _a.styles, container = _a.container;
        var disableVisibleItemsOnPrerenderMode = experimentsWrapper.getExperimentBoolean('specs.pro-gallery.disableVisibleItemsOnPrerenderMode');
        var key = 'fullscreen-pro-gallery-slider';
        if (isPreview) {
            key = JSON.stringify(__assign(__assign({}, container), styles));
        }
        return this.props.items.length > 0 ? (React.createElement("div", { className: 'pro-gallery-slider' },
            React.createElement(ProGalleryWrapper, { isPrerenderMode: this.props.isPrerenderMode, totalItemsCount: this.props.totalItemsCount, items: this.props.items, container: container, containerPostProcess: this.props.containerPostProcess, actions: this.props.actions, options: this.props.styles, settings: { isAccessible: this.props.isAccessible }, activeIndex: this.props.activeIndex, eventsListener: this.galleryEventsHandler, customNavArrowsRenderer: this.customArrowsRenderer, customInfoRenderer: this.props.customInfoRenderer, shouldValidateTypes: false, staticMediaUrls: this.props.staticMediaUrls, key: key, experimentalFeatures: {
                    disableVisibleItemsOnPrerenderMode: disableVisibleItemsOnPrerenderMode,
                } }))) : null;
    };
    ProGallerySlider.prototype.render = function () {
        return this.getGallerySlider();
    };
    return ProGallerySlider;
}(Component));
export default ProGallerySlider;
//# sourceMappingURL=ProGallerySlider.js.map